import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import FounderCredibility from "@/components/landing/FounderCredibility";
import Differentiation from "@/components/landing/Differentiation";
import Process from "@/components/landing/Process";
import Reviews from "@/components/landing/Reviews";
import FAQ from "@/components/landing/FAQ";
import Booking from "@/components/landing/Booking";
import Footer from "@/components/landing/Footer";
import BirdFlightIntro from "@/components/BirdFlightIntro";

export default function Landing() {
  return (
    <div className="bg-white text-[#1D1D1F]">
      <BirdFlightIntro />
      <Nav />
      <main>
        <Hero />
        <FounderCredibility />
        <Differentiation />
        <Process />
        <Reviews />
        <FAQ />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
